import { __rest } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import { PageContext } from './PageContext';
import { st, classes } from './Page.st.css.js';
export const PageSticky = (_a) => {
    var { children, className, style } = _a, props = __rest(_a, ["children", "className", "style"]);
    return (React.createElement(PageContext.Consumer, null, ({ stickyStyle }) => {
        let result;
        if (typeof children === 'function') {
            result = children({ style, className: classes.sticky });
        }
        else {
            result = (React.createElement("div", Object.assign({ className: st(classes.sticky, {}, className), style: Object.assign(Object.assign({}, stickyStyle), style) }, props), children));
        }
        return result;
    }));
};
PageSticky.displayName = 'Page.Sticky';
PageSticky.propTypes = {
    children: PropTypes.element.isRequired,
    style: PropTypes.object,
};
//# sourceMappingURL=PageSticky.js.map